import { useState, useEffect } from "react";
import { onValue, query, ref, off } from "firebase/database";
import { rtdb } from "../firebase";
import { ITelehealthCallParticipants } from "../utils/types";

export default function useTelehealthParticipants() {
    const [participants, setParticipants] = useState<
        ITelehealthCallParticipants[]
    >([]);

    useEffect(() => {
        const callRef = query(ref(rtdb, `/telehealth_calls/`));

        const unsubscribe = onValue(callRef, (snapshot) => {
            const callParticipants = snapshot.val();
            if (callParticipants) {
                const partcipantsArray = Object.keys(callParticipants).map(
                    (key) => ({ ...callParticipants[key] })
                );
                setParticipants(partcipantsArray);
            }
        });

        return () => {
            off(callRef, "value", unsubscribe);
        };
    }, []);

    const flatParticipants = participants.flatMap((callGroup) =>
        Object.values(callGroup || {}).filter(Boolean)
    );

    const isProviderOnCall = (sessionHistoryId: string) =>
        flatParticipants.some(
            (participant) =>
                participant.role === "provider" &&
                participant.status === "active" &&
                participant.session_history_id === sessionHistoryId
        );

    return { isProviderOnCall };
}
